import WordCard from './WordCard'
export default WordCard
